import { render } from "./SyncButtonElement.vue?vue&type=template&id=2d83db9e&scoped=true"
import script from "./SyncButtonElement.vue?vue&type=script&lang=js"
export * from "./SyncButtonElement.vue?vue&type=script&lang=js"

import "./SyncButtonElement.vue?vue&type=style&index=0&id=2d83db9e&scoped=true&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d83db9e"]])

export default __exports__